import { render, staticRenderFns } from "./CartShipping.vue?vue&type=template&id=49e7f00a&"
import script from "./CartShipping.vue?vue&type=script&lang=js&"
export * from "./CartShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports